<script>
import StoreCardMixin from '@phoenix/mixins/components/store/storeCardMixin';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';
import PhxPicture from '@maison/components/common/PhxPicture.vue';

export default {
  components: {
    PhxPicture,
    PhxsgButton,
  },

  mixins: [StoreCardMixin],

  props: {
    shouldDisplayActions: {
      type: Boolean,
      default: true,
    },

    shouldDisplayAddress: {
      type: Boolean,
      default: true,
    },

    clickable: {
      type: Boolean,
      default: true,
    },

    phoneCtaTracking: {
      type: String,
      default: null,
    },
  },

  computed: {
    cardClasses() {
      return ['page-push-card', { 'page-push-card--responsive-fluid': this.isReseller }];
    },
  },
};
</script>

<template>
  <div :class="cardClasses">
    <a
      v-if="image && clickable"
      class="picture picture--actionable page-push-card__picture picture--cover"
      :href="permalink"
    >
      <PhxPicture v-bind="image" />
    </a>
    <div v-else-if="image" class="picture picture--actionable page-push-card__picture picture--cover">
      <PhxPicture v-bind="image" />
    </div>

    <div class="page-push-card__content">
      <div class="page-push-card__content-inner">
        <div class="page-push-card__title heading">{{ title }}</div>
        <p v-if="phone" class="page-push-card__inline-link">
          <a
            :href="`tel:${phone.replace(/\s/g, '')}`"
            :dir="phoneLabel ? undefined : 'ltr'"
            :data-tracking="phoneCtaTracking"
          >
            {{ phoneLabel || phone }}
          </a>
        </p>
      </div>

      <div v-if="shouldDisplayActions" class="page-push-card__actions grid grid-cols-1 gap-sm">
        <div v-if="permalink">
          <phxsg-button
            use="a"
            variant="link"
            :href="permalink"
            :target="isOnline ? '_blank' : null"
            :icon="{ end: { id: 'chevron-right', bidirectional: true, size: 'sm' } }"
          >
            {{ seeMoreLabel }}
          </phxsg-button>
        </div>
      </div>
    </div>
  </div>
</template>
